import { apiPaths } from "@/config/urls";
import type { UserInfoResponse } from "@/types/user";

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop()?.split(";").shift() || null : null;
};

export const fetchUserInfo = async (service: string): Promise<UserInfoResponse | null> => {
  try {
    const isWyborcza = service === "wyborcza";
    const ssoCookie = isWyborcza ? getCookie("SsoSessionPermanent") : null;
    const url = isWyborcza
      ? `${apiPaths.USERINFO}?SsoSessionPermanent=${encodeURIComponent(ssoCookie || "")}`
      : `${globalThis.location.origin}/konto/getUserInfo.servlet`;

    const response = await fetch(url);

    

    if (!response.ok) {
      console.log("Failed to fetch user info:", response.statusText);
      return null;
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.log("Error fetching user info:", error);
    return null;
  }
};